import React, { useState, useEffect } from 'react';
import { waitForBraze } from '../braze/braze';
import { Inappmessages } from '../inappmessages/inappmessages';

export type BrazeiamProps = { userId: string | undefined };

export function Brazeiam({ userId }: BrazeiamProps) {
  const [braze, setBraze] = useState<any>(null);
  const [activeIam, setActiveIam] = useState<any>(null);

  function subscribeToInAppMessages() {
    console.log('::: Braze: subscribeToInAppMessages');
    if (!braze) {
      console.log(
        '::: Braze: An error occurred while trying to refer to the braze'
      );
      return;
    }

    braze.subscribeToInAppMessage((inAppMessage: any) => {
      console.log('::: Braze: inAppMessage 1', inAppMessage);
      if (inAppMessage instanceof braze.ControlMessage) {
        console.log('::: Braze: ControlMessage', inAppMessage);
        return braze.showInAppMessage(inAppMessage);
      }

      if (inAppMessage instanceof braze.InAppMessage) {
        console.log('::: Braze: inAppMessage 2', inAppMessage);
        console.log('::: Braze: inAppMessage 3', inAppMessage.message);

        setActiveIam(inAppMessage);

        const extras = inAppMessage.extras;
        if (extras) {
          for (const key in extras) {
            console.log(
              '::: Braze: inAppMessage key: ' + key + ', value: ' + extras[key]
            );
          }
        }
        braze.logInAppMessageImpression(inAppMessage);
      }
    });

    logCustomEvents();
  }

  function logCustomEvents () {
    console.log('::: Braze: logCustomEvents');
    // fixture_page_view
    if (braze && /^\/tickets\/.*-v-.*/.test(window.location.pathname)) {
      braze.logCustomEvent('fixture_page_view', {
        url: window.location.href
      });
    }
  };

  function changeUser(userId: string | undefined) {
    braze.getUser().getUserId((id: string | undefined) => {
      if (id === userId || !userId) return;
      braze.changeUser(userId);
    });
  }

  useEffect(() => {
    (async () => {
      const braze = await waitForBraze();
      setBraze(braze);
    })();
  }, []);

  useEffect(() => {
    if (braze && braze.initialize()) {
      subscribeToInAppMessages();
      changeUser(userId);
    }
  }, [braze]);

  return <>{activeIam && <Inappmessages data={activeIam} />}</>;
}
